<h2 mat-dialog-title>Enter Container Image Name</h2><br>
<mat-dialog-content>
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Image Name</mat-label>
    <input matInput [(ngModel)]="imageName" placeholder="friggkantine/main:latest">
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="imageName" [disabled]="!imageName.trim()" (click)="onDialogClose()">OK</button>
</mat-dialog-actions>
